// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2LIAl","vLegacy":"SelectSecondary_vLegacy__j_OrZ","error":"SelectSecondary_error__2ZvS8","disabled":"SelectSecondary_disabled__Ozh1j"};